import { bootstrapApplication } from '@angular/platform-browser';
import { initErrorMonitoring } from '@core-session';
import { PlatformType } from '@data-access';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

initErrorMonitoring(PlatformType.WebLogin);

bootstrapApplication(AppComponent, appConfig)
  // eslint-disable-next-line @/no-console
  .catch((err) => console.error(err));
